var exports = {
  "_Q": "backgroundContainer__hyZf88",
  "n1": "circle__uiXM-V",
  "sV": "circleLeft__CfHk7i",
  "yw": "circleMiddle__7p9y56",
  "LL": "circleRight__O-aTfb",
};

module.exports = exports;
